
import React, { Component } from 'react';
import { Icon } from '.';
import ClassNames from 'classnames';

export default class Accordion extends Component {

  constructor(props) {
    super(props);

    this.state = {
      open: props.startOpen || false,
    };
  }

  toggleAccordion() {
    this.setState({
      open: !this.state.open,
    });
  }

  render() {

    const accordionIcon = this.state.open ? 'chevron-down' : 'chevron-right';

    const collapseClasses = ClassNames({
      collapse: true,
      show: this.state.open,
    });

    const icon = this.props.showCaret ? (<Icon name={ accordionIcon } />) : null;

    return (
      <div className="accordion">
        <h5 className="header">
          <button
            className="btn btn-link"
            onClick={ this.toggleAccordion.bind(this) }
            type="button"
            aria-expanded="true"
            aria-controls="collapseOne">
            { this.props.title }
            { icon }
          </button>
        </h5>

        <div id="collapseKeyLimits" className={ collapseClasses } aria-labelledby="headingOne">
          { this.props.children }
        </div>
      </div>
    );

  }

}



// WEBPACK FOOTER //
// ./client/components/Accordion.jsx